import React, {useState, useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'
import calendrier from '../../assets/Milidou/calendrier.png'

function SimulTraitement() {
  const [goToPDL, setgoToPDL] = useState(false)
  const [tauxMax, settauxMax] = useState(75)
  const [dateTauxMax, setdateTauxMax] = useState("2025-06-22")
  
  const [dateTraitement, setdateTraitement] = useState()
  const [efficacite, setsefficacite] = useState("")
  const [estimationdateTraitement, setestimationdateTraitement] = useState('/')

  function handleClick(){
    setgoToPDL(true)
  }
  function formatDate(dateString) {
    const mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
    
    const [year, month, day] = dateString.split("-"); // Sépare l'année, le mois et le jour
    return `${parseInt(day)} ${mois[parseInt(month) - 1]}`; // Convertit le mois en texte
  }
  function handleDateTraitement(event){
    var datetrait = event.target.value
    setdateTraitement(datetrait)
  }
  function handleChangeEfficacite(event){
    var effice = event.target.value
    setsefficacite(effice)
  }


  if(goToPDL) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte`}/>
  }
  return (
    <div>
      <EnteteMildiou titre={'Simuler l’impact de mon traitement '}/>
      <FooterNavMildiou/>
      <div className='containerMildiou'>
        <div style={{marginBottom:'20px'}}><button className='titreMoins colorPrincipal' onClick={handleClick} style={{backgroundColor: 'transparent', border: 'none'}} > {'<'} Revenir </button></div> 
        <div className='titre' style={{width:'100%', margin:'0px', marginBottom:'20px', color:'#C61717'}}>Impact de mon dernier traitement :</div>
        <div className='row' style={{justifyContent:'flex-start', marginBottom:'30px', marginLeft:'2%'}}>
            <div className='titreMoins' style={{margin:'0px'}}>Date  : </div>
            <input 
            className='input titreMoinsMoins'
            value={dateTraitement}
            onChange={handleDateTraitement}
            type='date'
            style={{height:'80px', width:'50%', margin:'0px', marginLeft:'2%'}}
            />
          </div>
        
        <div className='titreMoins' style={{margin:'0px', marginLeft:'2%'}}>Efficacité estimée </div>
        <select id="selecteffice" value={efficacite} onChange={handleChangeEfficacite} className='titreMoinsMoins' style={{marginBottom:'30px', width:'95%', marginLeft:'2%'}}>
          <option value="">Sélectionnez une efficacité</option>
          <option value="90">90 %</option>
          <option value="80">80 %</option>
          <option value="70">70%</option>
          <option value="60">60 %</option>
          <option value="50">50 %</option>
          <option value="40">40%</option>
          <option value="30">30 %</option>
          <option value="20">20 %</option>
          <option value="10">10%</option>
        </select>

        <button className='validationMildiou'>
          <div className='texteValidationMildiou'> Simuler l'impact</div>
        </button>

        <div className='divInfestation'>
          <div className='titre' style={{width:'100%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>Sur la base de l’itinéraire climatique passé,</div>
          <div className='row'>
            <div className='row titreMoins' style={{width:'45%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>
              le taux maximal d’infestation probable est de 
            </div>
            <div className='row titreMoins' style={{width:'45%', textAlign:'center', margin:'0px', marginBottom:'20px', color:'#C61717'}}>
              et pourra être atteint le 
            </div>
          </div>
          <div className='row' style={{alignItems:'flex-start'}}>
            <div className='row' style={{width:'45%'}}>
              <div className='carreInfo' style={{width:'80%', marginBottom:'5px'}}> {tauxMax} % </div>
            </div>
            <div className='row' style={{width:'45%'}}>
              <div className='carreInfo' style={{width:'80%', marginBottom:'5px'}}> {dateTauxMax === "/" ? "/" : formatDate(dateTauxMax)} </div>
            </div>
          </div>
          <div className='row' style={{alignItems:'flex-start', marginBottom:'0px'}}>
            <div className='row' style={{width:'45%', marginBottom:'0px'}}>
              <div className='titreMoins' style={{width:'100%', textAlign:'center', margin:'0px', color:'#C61717'}}>des ceps</div>
            </div>
            <div className='row' style={{width:'45%', marginBottom:'0px'}}>
              {/* laisser vide */}
            </div>
          </div>
        </div>

        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', paddingLeft:'2%',paddingRight:'2%', marginTop:'30px'}}>
          <div style={{width:'75%'}}>
            <div className='titreMoins' style={{margin:'0px'}}>Estimation de la prochaine intervention : </div>
          </div>
          <div className='row' style={{width:'25%'}}>
            <img src={calendrier} alt="calendrier" style={{width:'20%'}}/>
            <div className='titreMoins' style={{margin:'0px'}}>{estimationdateTraitement === "/" ? "/" : formatDate(estimationdateTraitement)}</div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default SimulTraitement